/* V2.26 — flush masonry wall + inner-image parallax.
   Builds real flex columns (5 desktop / 3 tablet / 2 mobile) from the gallery
   items; per-column aspect-ratio patterns (see evertaste.css) sum equal, so
   every column bottom lands on the same line. Photo #16 shows on mobile only
   (16 = 2x8; 15 = 5x3 and 3x5). Parallax happens INSIDE each fixed frame
   (img is 118% tall and glides within overflow:hidden), so the flush edges
   never move. Disabled for prefers-reduced-motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var grid = document.querySelector('.ek-gallery--bleed .ek-gallery__grid');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.ek-gallery__item'));
    if (items.length < 6) return;
    if (items[15]) items[15].classList.add('ek-item-extra');

    var currentN = 0;
    function colCount() {
      var w = window.innerWidth;
      return w >= 990 ? 5 : w >= 750 ? 3 : 2;
    }

    function build() {
      var n = colCount();
      if (n === currentN) return;
      currentN = n;
      Array.prototype.slice.call(grid.querySelectorAll('.ek-mcol')).forEach(function (col) {
        while (col.firstChild) grid.appendChild(col.firstChild);
        col.parentNode.removeChild(col);
      });
      var visible = items.filter(function (it) {
        return getComputedStyle(it).display !== 'none';
      });
      var per = Math.ceil(visible.length / n);
      grid.classList.add('ek-built');
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div');
        col.className = 'ek-mcol';
        visible.slice(c * per, (c + 1) * per).forEach(function (it) {
          col.appendChild(it);
        });
        grid.appendChild(col);
      }
    }

    var ticking = false;
    function paint() {
      ticking = false;
      if (reduced) return;
      var vh = window.innerHeight;
      if (!vh) return;
      items.forEach(function (it) {
        var img = it.querySelector('img');
        if (!img) return;
        var r = it.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        p = Math.max(-0.6, Math.min(0.6, p));
        img.style.transform = 'translateY(' + (-9 + p * 10) + '%)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(paint); }
    }

    build();
    window.addEventListener('resize', function () { build(); onScroll(); });
    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  });
})();
